import { useEffect, useState } from 'react';
import { Avatar, Box, Card, CardContent, Grid, Typography } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import Conexion from '../../../Conexion/Conexion';

const { apiUrl } = Conexion();

async function obtenerDato() {
  return fetch(`${apiUrl}/api/dashboard/ingresos-checkeados`, {
      method: 'GET',
      headers: {
          'Content-Type': 'application/json',
          'Authorization': sessionStorage.getItem('token')
      }
  })
      .then(result => result.json())
}

const IngresosCheckeados = (props) => {

  const [state, setState] = useState([{monto:0}]);

  const cargarDatos = async () => {
    const ingresos = await obtenerDato();
    if (ingresos.ok) {
      setState(ingresos.data);
    }
  }

  useEffect(() => {
    cargarDatos();
  }, []);

  return(
    <Card {...props}>
      <CardContent>
        <Grid
          container
          spacing={3}
          sx={{ justifyContent: 'space-between' }}
          >
          <Grid item>
            <Typography
              color="textSecondary"
              gutterBottom
              variant="overline"
              className='semiBold'
              >
              INVITACIONES ESCANEADAS
            </Typography>
            <Typography
              color="textPrimary"
              variant="h4"
            >
              {state[0].count || 0}
            </Typography>
          </Grid>
          <Grid item>
            <Avatar
              sx={{
                backgroundColor: 'warning.main',
                height: 56,
                width: 56
              }}
              >
              <QrCodeScannerIcon />
            </Avatar>
          </Grid>
        </Grid>
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            pt: 2
          }}
          >
          {/* <ArrowUpwardIcon color="success" />
          <Typography
            variant="body2"
            sx={{
              mr: 1
            }}
          >
            
          </Typography> */}
          <Typography
            color="textSecondary"
            variant="caption"
          >
            De los últimos 30 días
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
}

export default IngresosCheckeados;